module.exports = __webpack_public_path__ + "img/1601.787f4ec0.png";